var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "field is-horizontal" }, [
      _vm._m(0),
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c(
            "div",
            { staticClass: "control is-expanded" },
            [
              _c("multiselect", {
                attrs: {
                  id: "toemails-multiselect",
                  options: _vm.availableToEmails,
                  multiple: true,
                  "close-on-select": false,
                  "clear-on-select": true,
                  "preserve-search": true,
                  taggable: true,
                  placeholder: "Enter email address or search",
                  "tag-placeholder": "Press enter to add email",
                  label: "email",
                  "track-by": "email",
                  "show-labels": false,
                  searchable: true,
                  "internal-search": false,
                },
                on: {
                  tag: _vm.addEmailTag,
                  "search-change": _vm.getAssetsEmailAddresses,
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function (props) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "tag is-pulled-right",
                            class: {
                              "is-success":
                                props.option.assetTypeName === "Customer",
                              "is-info":
                                props.option.assetTypeName === "Insurer",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(props.option.assetTypeName) + " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(props.option.name) +
                              " <" +
                              _vm._s(props.option.email) +
                              ">"
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "tag",
                    fn: function (props) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "tag is-primary multiselect-email-tag",
                          },
                          [
                            _vm._v(" " + _vm._s(props.option.email) + " "),
                            _c("button", {
                              staticClass: "delete is-small",
                              on: {
                                click: function ($event) {
                                  return props.remove(props.option)
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedToEmails,
                  callback: function ($$v) {
                    _vm.selectedToEmails = $$v
                  },
                  expression: "selectedToEmails",
                },
              }),
              !_vm.isValidToEmail
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Invalid email address"),
                  ])
                : _vm._e(),
              _vm.showToHint
                ? _c("span", { staticClass: "help is-info" }, [
                    _vm._v("Press <Enter> key to add email address"),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { tabindex: "-1" },
              on: { click: _vm.toggleCc },
            },
            [
              _c("span", { staticClass: "icon is-small is-left" }, [
                _c("i", {
                  staticClass: "mdi mdi-24px",
                  class: [_vm.showCc ? "mdi-chevron-up" : "mdi-chevron-down"],
                }),
              ]),
              _c("span", [_vm._v("Cc")]),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "button",
              staticStyle: { "margin-left": "0.5em" },
              attrs: { tabindex: "-1" },
              on: { click: _vm.toggleBcc },
            },
            [
              _c("span", { staticClass: "icon is-small is-left" }, [
                _c("i", {
                  staticClass: "mdi mdi-24px",
                  class: [_vm.showBcc ? "mdi-chevron-up" : "mdi-chevron-down"],
                }),
              ]),
              _c("span", [_vm._v("Bcc")]),
            ]
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCc,
            expression: "showCc",
          },
        ],
        staticClass: "field is-horizontal",
      },
      [
        _vm._m(1),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              { staticClass: "control is-expanded" },
              [
                _c("multiselect", {
                  attrs: {
                    id: "ccemails-multiselect",
                    options: _vm.availableCcEmails,
                    multiple: true,
                    "close-on-select": false,
                    "clear-on-select": true,
                    "preserve-search": true,
                    taggable: true,
                    placeholder: "Enter email address or search",
                    "tag-placeholder": "Press enter to add email",
                    label: "email",
                    "track-by": "email",
                    "show-labels": false,
                    searchable: true,
                    "internal-search": false,
                  },
                  on: {
                    tag: _vm.addEmailTag,
                    "search-change": _vm.getAssetsEmailAddresses,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function (props) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag is-pulled-right",
                              class: {
                                "is-success":
                                  props.option.assetTypeName === "Customer",
                                "is-info":
                                  props.option.assetTypeName === "Insurer",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(props.option.assetTypeName) + " "
                              ),
                            ]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(props.option.name) +
                                " <" +
                                _vm._s(props.option.email) +
                                ">"
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function (props) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag is-primary multiselect-email-tag",
                            },
                            [
                              _vm._v(" " + _vm._s(props.option.email) + " "),
                              _c("button", {
                                staticClass: "delete is-small",
                                on: {
                                  click: function ($event) {
                                    return props.remove(props.option)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedCcEmails,
                    callback: function ($$v) {
                      _vm.selectedCcEmails = $$v
                    },
                    expression: "selectedCcEmails",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBcc,
            expression: "showBcc",
          },
        ],
        staticClass: "field is-horizontal",
      },
      [
        _vm._m(2),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              { staticClass: "control is-expanded" },
              [
                _c("multiselect", {
                  attrs: {
                    id: "bccemails-multiselect",
                    options: _vm.availableBccEmails,
                    multiple: true,
                    "close-on-select": false,
                    "clear-on-select": true,
                    "preserve-search": true,
                    taggable: true,
                    placeholder: "Enter email address or search",
                    "tag-placeholder": "Press enter to add email",
                    label: "email",
                    "track-by": "email",
                    "show-labels": false,
                    searchable: true,
                    "internal-search": false,
                  },
                  on: {
                    tag: _vm.addEmailTag,
                    "search-change": _vm.getAssetsEmailAddresses,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function (props) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag is-pulled-right",
                              class: {
                                "is-success":
                                  props.option.assetTypeName === "Customer",
                                "is-info":
                                  props.option.assetTypeName === "Insurer",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(props.option.assetTypeName) + " "
                              ),
                            ]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(props.option.name) +
                                " <" +
                                _vm._s(props.option.email) +
                                ">"
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function (props) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag is-primary multiselect-email-tag",
                            },
                            [
                              _vm._v(" " + _vm._s(props.option.email) + " "),
                              _c("button", {
                                staticClass: "delete is-small",
                                on: {
                                  click: function ($event) {
                                    return props.remove(props.option)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedBccEmails,
                    callback: function ($$v) {
                      _vm.selectedBccEmails = $$v
                    },
                    expression: "selectedBccEmails",
                  },
                }),
                !_vm.isValidBccEmail
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Invalid email address"),
                    ])
                  : _vm._e(),
                _vm.showBccHint
                  ? _c("span", { staticClass: "help is-info" }, [
                      _vm._v("Press <Enter> key to add email address"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showCc || _vm.showBcc,
          expression: "showCc || showBcc",
        },
      ],
      staticClass: "is-divider",
    }),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "field is-horizontal",
      },
      [_vm._m(3), _vm._m(4)]
    ),
    _c("div", { staticClass: "field is-horizontal" }, [
      _vm._m(5),
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control is-expanded" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.innerEmailer.subject,
                  expression: "innerEmailer.subject",
                },
              ],
              staticClass: "input",
              attrs: { type: "text", placeholder: "Subject" },
              domProps: { value: _vm.innerEmailer.subject },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.innerEmailer, "subject", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field is-horizontal" }, [
      _vm._m(6),
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control is-expanded" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.innerEmailer.message,
                  expression: "innerEmailer.message",
                },
              ],
              staticClass: "textarea",
              attrs: { rows: "10", placeholder: "" },
              domProps: { value: _vm.innerEmailer.message },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.innerEmailer, "message", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field is-horizontal" }, [
      _vm._m(7),
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c(
            "div",
            { staticClass: "control is-expanded" },
            [
              _c("vue-input-tag", {
                attrs: {
                  tags: _vm.combinedAttachments,
                  "tag-colour": "is-turquoise",
                  "allow-input": false,
                },
                on: { "remove-tag": _vm.handleRemovedTag },
                scopedSlots: _vm._u([
                  {
                    key: "tag",
                    fn: function ({ tag }) {
                      return [
                        _c("span", [_vm._v(_vm._s(tag.fileName))]),
                        tag.fileSize > 0
                          ? _c(
                              "span",
                              { staticClass: "ml-1 is-size-7 has-text-grey" },
                              [
                                _vm._v(
                                  " (" +
                                    _vm._s(_vm.formatFileSize(tag.fileSize)) +
                                    ") "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm.combinedAttachments.length > 0
                ? _c("div", { staticClass: "mt-2" }, [
                    _c("div", { staticClass: "level is-mobile mb-1" }, [
                      _c("div", { staticClass: "level-left" }, [
                        _c("div", { staticClass: "level-item" }, [
                          _c(
                            "span",
                            { staticClass: "has-text-grey is-size-7" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.combinedAttachments.length) +
                                  " files - " +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.totalAttachmentSize)
                                  ) +
                                  " total "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "level-right" }, [
                        _c("div", { staticClass: "level-item" }, [
                          _c(
                            "span",
                            { staticClass: "has-text-grey is-size-7" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.totalAttachmentSize)
                                  ) +
                                  " / 25 MB "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "progress-container mb-2" }, [
                      _c(
                        "progress",
                        {
                          staticClass: "progress is-small",
                          class: {
                            "is-danger": _vm.isAttachmentSizeExceeded,
                            "": !_vm.isAttachmentSizeExceeded,
                          },
                          attrs: { max: 25 * 1024 * 1024 },
                          domProps: { value: _vm.totalAttachmentSize },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                Math.round(
                                  (_vm.totalAttachmentSize /
                                    (25 * 1024 * 1024)) *
                                    100
                                )
                              ) +
                              "% "
                          ),
                        ]
                      ),
                    ]),
                    _vm.isAttachmentSizeExceeded
                      ? _c("div", { staticClass: "attachment-warning" }, [
                          _vm._m(8),
                          _c("span", [
                            _vm._v(
                              "Total attachment size (" +
                                _vm._s(
                                  _vm.formatFileSize(_vm.totalAttachmentSize)
                                ) +
                                ") exceeds the 25MB limit."
                            ),
                            _c("br"),
                            _vm._v(" Please remove some files."),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("To")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Cc")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Bcc")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("From")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-body" }, [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control is-expanded" }, [
          _c("input", {
            staticClass: "input",
            attrs: { type: "text", placeholder: "" },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Subject")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Message")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Attachments")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-large mr-1" }, [
      _c("i", { staticClass: "mdi mdi-alert mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }